import { theme } from '@approvalmax/theme';
import { Button, Field, font } from '@approvalmax/ui';
import styled from 'styled-components';

export const Card = styled.div`
    display: flex;
    flex-flow: column;
    width: 620px;
    max-width: 100%;
    padding: 30px 50px 40px 50px;
    background: #fff;
    border-radius: 8px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        padding: 40px 15px 50px;
        width: auto;
    }
`;

export const Title = styled.div`
    text-align: center;
    ${font(16, '#000', 'semibold')}
`;

export const PasswordField = styled(Field)`
    margin-top: 15px;
    margin-bottom: 15px;
`;

export const Buttons = styled.div`
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
    width: 100%;
`;
